// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2HPNL","options":"AnswerScale_options__2_qMO","selected":"AnswerScale_selected__2R5bv"};